import { Stack, Typography } from '@mui/material';
import { BlacklistTypes } from 'features/co-pilot/company-blacklists/company-blacklist.types';
import PaiDropzone from 'features/ui/base-components/pai-dropzone';
import PaiLink from 'features/ui/base-components/pai-link';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import FileColumnSelection from './file-column-selection';

interface Props {
  blacklistType: BlacklistTypes;
  columns: { text: string; type: string }[];
  data: string[][];
  fileName: string;
  hasTableHeading: boolean;

  blacklistItems: { url?: string; company?: string }[];

  onFileDrop(acceptedFiles: any): void;

  handleColumnTypeChange(idx: number): (event: React.ChangeEvent<HTMLInputElement>) => void;

  handleHasTableHeadingChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleAcceptColumns(): void;

  handleResetBlacklistItems(): void;

  handleResetFileColumnSelection(): void;
}

const BlacklistFileUpload: React.FC<Props> = ({
  blacklistType,
  columns,
  data,
  fileName,
  hasTableHeading,
  blacklistItems,
  onFileDrop,
  handleColumnTypeChange,
  handleHasTableHeadingChange,
  handleAcceptColumns,
  handleResetBlacklistItems,
  handleResetFileColumnSelection,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Stack gap={2}>
      {_.isEmpty(data) ? (
        <PaiDropzone maxWidth={'100%'} height={'200px'} onDrop={onFileDrop} />
      ) : (
        <FileColumnSelection
          blacklistType={blacklistType}
          columns={columns}
          fileName={fileName}
          hasTableHeading={hasTableHeading}
          handleColumnTypeChange={handleColumnTypeChange}
          handleHasTableHeadingChange={handleHasTableHeadingChange}
          handleAcceptColumns={handleAcceptColumns}
          handleResetFileColumnSelection={handleResetFileColumnSelection}
        />
      )}
      {!_.isEmpty(blacklistItems) ? (
        <>
          <Stack direction={'row'} gap={2}>
            <Typography className={classes.primaryText}>
              {t('itemsToBeAdded', {
                count: blacklistItems.length,
                item: blacklistType === BlacklistTypes.CONTACT ? t('contacts') : t('companies'),
              })}
            </Typography>
            <PaiLink text={t('resetList')} action={handleResetBlacklistItems} size={'lg'} variant={'default'} underline={'always'} />
          </Stack>
        </>
      ) : null}
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  primaryText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
}));

export default BlacklistFileUpload;
